import axios from 'axios';
import React, { useState } from 'react'
import { Col, FormGroup, Label, Input, Button } from 'reactstrap';
import Swal from 'sweetalert2';

function LiquidityForm() {
    const [newformData, setFormData] = useState({
        first_name: '', last_name: '', email: '', contact: '',
        number_token: '', erc_address: '', total_payment: '', transaction_id: ''
    })
    const handalSubmit = () => {
        if (newformData.email === '' || newformData.first_name === '' ||
            newformData.number_token === '' || newformData.erc_address === '' ||
            newformData.total_payment === ''
        ) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill up all fields!",
                footer: ''
            });
            return
        }
        axios.post(`${process.env.REACT_APP_API_URL}/liquidity-offer/add`, newformData)


        setTimeout(() => {
            setFormData({
                first_name: '', last_name: '', email: '', contact: '',
                number_token: '', erc_address: '', total_payment: '', transaction_id: ''
            });
            Swal.fire({
                icon: "success",
                title: "Successfully saved",
                showConfirmButton: false,
                timer: 2000
            });
        }, 1000);


    }
    return (
        <div className=' token-swap'>
            <FormGroup row>
                <Label sm={2} >FIRST NAME </Label>
                <Col sm={4}>
                    <Input type="text" value={newformData.first_name}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, first_name: e.target.value })) }}
                    />
                </Col>
                <Label sm={2} >LAST NAME</Label>
                <Col sm={4}>
                    <Input type="text" value={newformData.last_name}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, last_name: e.target.value })) }}
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label sm={2} >EMAIL</Label>
                <Col sm={4}>
                    <Input type="text" value={newformData.email}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, email: e.target.value })) }}
                    />
                </Col>
                <Label sm={2} >CONTACT</Label>
                <Col sm={4}>
                    <Input type="text" value={newformData.contact}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, contact: e.target.value })) }}
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label sm={4} >
                    Number of NGTG Tokens You Wish to Purchase

                </Label>
                <Col sm={2}>
                    <Input type="text" value={newformData.number_token}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, number_token: e.target.value })) }}
                    />
                </Col>
                <Label sm={4} >Your ERC-20 Address for Receiving NGTG Tokens:
                </Label>
                <Col sm={2}>
                    <Input type="text" value={newformData.erc_address}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, erc_address: e.target.value })) }}
                    />
                </Col>
            </FormGroup>
            <FormGroup row>
                <Label sm={4} >
                    Total Payment Amount (in USDT)
                </Label>
                <Col sm={2}>
                    <Input type="text" value={newformData.total_payment}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, total_payment: e.target.value })) }}
                    />
                </Col>
                <Label sm={4} >Transaction ID of Your USDT Transfer:
                </Label>
                <Col sm={2}>
                    <Input type="text" value={newformData.transaction_id}
                        onChange={(e) => { setFormData((prev) => ({ ...prev, transaction_id: e.target.value })) }}
                    />
                </Col>
            </FormGroup>
            <div>
                <p><b>
                    Payment Instructions:
                </b></p>
                <ul>
                    <li>
                        Please transfer the total USDT amount to the following wallet address:
                    </li>
                    <li>
                        Nuggettrap ERC-20 Wallet Address for USDT Payment: 0x092D990971f40E012aa4d7C27D079E913bF250b8
                    </li>
                </ul>
            </div>
            <FormGroup check>
                <Input type="checkbox" />
                {' '}
                <Label check>
                    <b>Declaration:</b> I confirm that the details provided above are accurate and that I have transferred the USDT to the specified wallet address
                </Label>
            </FormGroup>
            <Button onClick={handalSubmit}>
                Submit
            </Button>
        </div>
    )
}

export default LiquidityForm